document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("slider-component").forEach((slider) => {
    const autoplay = slider.dataset.autoplay === "true";
    const loop = slider.dataset.loop === "true";
    const interval = parseInt(slider.dataset.interval, 10) || 1000;

    if (autoplay) {
      let autoplayInterval;

      const startAutoplay = () => {
        autoplayInterval = setInterval(() => {
          const nextButton = slider.querySelector(".slider-button--next");
          if (nextButton) nextButton.click();
        }, interval);
      };

      const stopAutoplay = () => clearInterval(autoplayInterval);

      slider.addEventListener("mouseover", stopAutoplay);
      slider.addEventListener("mouseout", startAutoplay);

      startAutoplay();
    }

    if (loop) {
      const slides = slider.querySelectorAll(".slider__slide");
      const lastSlide = slides[slides.length - 1];
      const firstSlide = slides[0];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target === lastSlide) {
            slider.scrollTo({ left: 0, behavior: "smooth" });
          } else if (entry.isIntersecting && entry.target === firstSlide) {
            slider.scrollTo({ left: slider.scrollWidth, behavior: "smooth" });
          }
        });
      });

      observer.observe(firstSlide);
      observer.observe(lastSlide);
    }
  });
});
